import React, { useEffect, useState, createRef, Fragment } from "react";
import "../../assets/css/business-partner/partner-detail.css";
import AutoComplete from "../components/autocomplete-input";
import SearchIcon from "@mui/icons-material/Search";
import TextFiealdInput from "../components/textFiald";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import CancelIcon from "@mui/icons-material/Cancel";
import Checkbox from "@mui/material/Checkbox";
import DownloadIcon from "@mui/icons-material/Download";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import StepConnector, {
  stepConnectorClasses,
} from "@mui/material/StepConnector";
import AutoCompleteMultiple from "../components/multi-drop-down";

import { useSelect } from "@mui/base";
import TabContext from "@mui/lab/TabContext";
import MainTable from "../components/main-tables";
import TabList from "@mui/lab/TabList";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Autocomplete,
  Button,
  DialogActions,
  FormControl,
  FormControlLabel,
  FormGroup,
  Grid,
  InputAdornment,
  MenuItem,
  Select,
  Tooltip,
  useMediaQuery,
} from "@mui/material";
import Tab from "@mui/material/Tab";
import TabPanel from "@mui/lab/TabPanel";
import { useSelector, useDispatch } from "react-redux";
import {
  partner_master_isFirst,
  raise_api_call_list_partner_master,
} from "../../redux/business-partner/partner-master/list-partner-master";
import { addPartnerData } from "../../redux/business-partner/partner-master/partner-master-first-data";
import { useNavigate } from "react-router";
import {
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField,
} from "@mui/material";
import { useFormik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import {
  success_api_call_Create_partner,
  Create_partner_is_success,
} from "../../redux/business-partner/partner-master/create-partner-master-reducer";
import {
  approve_partner_complete_api,
  approve_partner_is_succese,
  management_approve_partner,
} from "../../redux/business-partner/partner-master/approve-partner";
import { configs } from "../../common";
import {
  convert_sap_from_api,
  convert_sap_is_first,
} from "../../redux/business-partner/partner-master/move-xml-data";
import {
  clear_single_partner_details,
  raise_api_call_list_partner_one_detail,
} from "../../redux/business-partner/partner-master/list-one-partner-details";
import CompletePopup from "../components/response-pop-up";
import EditIcon from "@mui/icons-material/Edit";
import { raise_api_call_list_general_setting } from "../../redux/general-setting/list-general-setting-reducer";
import SearchImg from "../../assets/images/search.svg";
import FilterImg from "../../assets/images/filter.svg";
import DataNotFound from "../../assets/images/no_data_found.svg";
import { useCommonContext } from "../../Utils/commonContext";
//file supported formats
const SUPPORTED_FORMATS = [
  "image/jpg",
  "image/jpeg",
  "image/gif",
  "image/png",
  "application/pdf",
];

const statusItems = [
  {
    className: "approve_sts",
    label: "approved",
  },
  { className: "reject_sts", label: "reject" },
  {
    className: "request_sts",
    label: "request",
  },
  {
    className: "request_sts",
    label: "request",
  },
  {
    className: "completed_sts",
    label: "completed",
  },
  {
    className: "completed_sts",
    label: "submitted",
  },
];

const statusOrder = [
  "Request send to management",
  "Management  Approved ",
  "Request For Clarification",
  "Partner Onboarding Completed",
  "Request Send to Account Head",
  "Account Head  Approved ",
  "Account Head Rejected",
  "Management Rejected",
  "Clarification Submitted",
  "Others",
];

const Management = () => {
  const [country_code, setCountry_code] = React.useState(91);
  const dispatch = useDispatch();
  const [responsePopup, setResponsePopup] = useState<boolean>(false);
  const [activePartner, setActivePartner] = React.useState<null | number>(0);
  const isMobileView = useMediaQuery("(max-width: 1050px)");
  const { setTitleContext, setShowBack, setOnBackClick } = useCommonContext();

  const PartnerMasterList = useSelector(
    (state: any) => state.listPartnerMaster
  );
  const managementApproveApi = useSelector(
    (state: any) => state.ApprovePartner
  );
  const movedSap = useSelector((state: any) => state.PartnerMasterToSap);
  const generalSettingList = useSelector((state: any) => state.GeneralSetting);
  const navigate = useNavigate();
  const activeDatas = useSelector((state: any) => state.listOnePartnerDetail);
  const activeData =
    activeDatas.data.length != 0 ? activeDatas.data.result[0] : {};
  const [expanded, setExpanded] = useState<string | false>("panel1");

  const handleAccChange =
    (panel: string) => (event: any, newExpanded: boolean) => {
      setExpanded(newExpanded ? panel : false);
    };

  const validationSchema = Yup.object().shape({
    about: Yup.string().required("reason Is Required"),
  });
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      about: "",
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      submit(values);
    },
  });
  const {
    values,
    handleBlur,
    handleChange,
    handleSubmit,
    touched,
    setFieldValue,
    setFieldTouched,
    resetForm,
    errors,
  } = formik;
  // if (firstData) {
  //   if (PartnerMasterList.data.length != 0) {
  //     setFirstData(false);
  //     if (PartnerMasterList.isFirst) {
  //       setActivePartner(PartnerMasterList.data.result[0]);
  //       dispatch(partner_master_isFirst(""));
  //     }
  //   }
  // }

  const statusClassName = (value: string) => {
    return statusItems.find((it) =>
      value.trim().toLocaleLowerCase().includes(it.label)
    )?.className;
  };

  // submit
  const submit = (e: any) => {
    const data = {
      id: activeData.id,
      status: "rejected",
      description: e.about,
      url: "update_management",
    };
    if (!managementApproveApi.isLoading) {
      dispatch(management_approve_partner(data));
    }
  };

  console.log(activeData);

  // steppers

  const steps = [
    "Employee",
    "Management",
    "Partner",
    "Accounts",
    "Accounts Head",
    "SAP",
  ];
  const payment_terms =
    generalSettingList.data.length != 0
      ? generalSettingList.data.status
        ? generalSettingList.data.result
            .filter((e: any) => {
              if (e.page === "Payment Terms") {
                return e;
              }
            })
            .map((e: any) => {
              const data = { label: e.description, value: e.name };
              return data;
            })
        : [{ label: "No data", value: null }]
      : [{ label: "No data", value: null }];

  //
  const [value, setValue] = React.useState("1");
  const [search, setSearch] = useState<string>("");
  //   Dialog
  const [open, setOpen] = React.useState(false);
  const [managementReject, setManagementReject] = React.useState(false);
  const [managementEdit, setManagementEdit] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  //  and approve
  const RejectManagement = () => {
    setManagementReject(true);
  };

  const EditManagement = () => {
    setManagementEdit(true);
    navigate("/business-partner/onboarding/edit");
  };
  const ManagementRejectClose = () => {
    setManagementReject(false);
  };
  const handleTabChange = (event: React.SyntheticEvent, newValue: string) => {
    setValue(newValue);
  };
  const steperData = activeData.approvall
    ? activeData.approvall.length != 0
      ? activeData.approvall[activeData.approvall.length - 1].role_name ===
        "employee"
        ? 0
        : activeData.approvall[activeData.approvall.length - 1].role_name ===
          "management"
        ? 1
        : activeData.approvall[activeData.approvall.length - 1].role_name ===
          "partner"
        ? 2
        : activeData.approvall[activeData.approvall.length - 1].role_name ===
          "account_team"
        ? 3
        : activeData.approvall[activeData.approvall.length - 1].role_name ===
            "account_head" &&
          activeData.approvall[activeData.approvall.length - 1].status !=
            "approved"
        ? 4
        : activeData.approvall[activeData.approvall.length - 1].role_name ===
            "account_head" &&
          activeData.approvall[activeData.approvall.length - 1].status ===
            "approved"
        ? 6
        : 6
      : 0
    : 0;
  const isRejected = activeData.approvall
    ? activeData.approvall.length != 0
      ? activeData.approvall[activeData.approvall.length - 1].status ===
        "rejected"
        ? true
        : false
      : false
    : false;
  // console.log(isRejected);
  // useEfect

  useEffect(() => {
    dispatch(raise_api_call_list_partner_master(""));
    dispatch(raise_api_call_list_general_setting(""));

    if (managementApproveApi.isSuccess) {
      dispatch(approve_partner_is_succese(""));
      dispatch(raise_api_call_list_partner_one_detail("?id=" + activeData.id));
      // console.log(managementApproveApi);
      setOpen(false);
      ManagementRejectClose();
    }
    if (managementApproveApi.api_completed) {
      setResponsePopup(true);
      dispatch(approve_partner_complete_api(false));
    }
  }, [managementApproveApi]);

  // stepper line color change

  const ColorlibConnector = styled(StepConnector)(({ theme }) => ({
    [`&.${stepConnectorClasses.alternativeLabel}`]: {},
    [`&.${stepConnectorClasses.active}`]: {
      [`& .${stepConnectorClasses.line}`]: {
        background: "#82CA89",
      },
    },
    [`&.${stepConnectorClasses.completed}`]: {
      [`& .${stepConnectorClasses.line}`]: {
        background: "#82CA89",
      },
    },
    [`& .${stepConnectorClasses.line}`]: {
      height: 3,
      border: 0,
      backgroundColor:
        theme.palette.mode === "dark" ? theme.palette.grey[800] : "#eaeaf0",
      borderRadius: 1,
    },
  }));

  const handleBack = () => {
    dispatch(clear_single_partner_details(""));
    setShowBack(false);
    setTitleContext("Management");
  };

  useEffect(() => {
    setOnBackClick(() => handleBack);
    return () => {
      setShowBack(false);
      setTitleContext("");
    };
  }, []);

  useEffect(() => {
    if (activeData?.company_name) {
      setShowBack(true);
    }
  }, [activeData]);

  useEffect(() => {
    setTitleContext(activeData.company_name ?? "Management");
  }, [activeData]);

  const groupedDataBase = PartnerMasterList?.data?.result
    ? PartnerMasterList?.data?.result
        ?.filter((item: any) =>
          Object.values(item)
            .join("")
            .toLowerCase()
            .includes(search.toLowerCase())
        )
        .reduce((acc: any, item: any) => {
          const st = item.status || "Others";
          if (!acc[st]) acc[st] = [];
          acc[st].push(item);
          return acc;
        }, {})
    : [];

  const groupedData = statusOrder.map((status) => ({
    status,
    items: groupedDataBase[status] || [],
  }));

  return (
    <div className="partner-details">
      {responsePopup ? (
        <CompletePopup
          data={managementApproveApi}
          responsePopup={responsePopup}
          setCompletePopup={(e: any) => {
            setResponsePopup(false);
          }}
        />
      ) : (
        ""
      )}
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={
          PartnerMasterList.isLoading ||
          activeDatas.isLoading ||
          managementApproveApi.isLoading
            ? true
            : false
        }
      >
        {/* <CircularProgress color="inherit" /> */}
        <img
          style={{
            height: "150px",
          }}
          src={require("../../assets/images/3.gif")}
        ></img>
      </Backdrop>

      <div className={`content_container`}>
        <div
          className={`mini_side_container`}
          style={{
            display: isMobileView && activeData.id ? "none" : "initial",
          }}
        >
          <h5 className="f4 primary_text" style={{ paddingBottom: "10px" }}>
            Partner Details
          </h5>
          <div className="side_search_container">
            <TextField
              autoComplete="off"
              autoCorrect="off"
              spellCheck={false}
              placeholder="Search"
              className="side_search"
              name="search"
              onChange={(e) => {
                setSearch(e.target.value);
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <img src={SearchImg} alt="search" width="20px" />
                  </InputAdornment>
                ),
                style: {
                  borderRadius: "0px",
                  height: "45px",
                },
              }}
            />
            {/* <Button className="side_filter" disableRipple>
              <img src={FilterImg} alt="" />
            </Button> */}
          </div>
          <div className="side_content_container">
            {groupedData.map((group, index) => (
              <Fragment>
                {group.items.length > 0 && (
                  <Accordion
                    key={group.status}
                    className="business_partner_acc"
                    expanded={expanded === `panel${index + 1}`}
                    onChange={handleAccChange(`panel${index + 1}`)}
                  >
                    <AccordionSummary
                      className={`${statusClassName(group.status)}`}
                      expandIcon={<FontAwesomeIcon icon="caret-down" />}
                    >
                      <h4 className={`f5`}>{group.status}</h4>
                    </AccordionSummary>

                    <AccordionDetails>
                      {group.items.map((e: any, key: any) => (
                        <div
                          key={key}
                          onClick={() => {
                            setActivePartner(key);
                            dispatch(
                              raise_api_call_list_partner_one_detail(
                                "?id=" + e.id
                              )
                            );
                          }}
                          className="side_content_card"
                        >
                          <div
                            className={`side_content_mini_card ${
                              e.id === activeData.id ? "active" : ""
                            }`}
                          >
                            <div className="side_content_footer side_content_footer2">
                              <div className="f4 title">
                                {e.company_name
                                  ? e.company_name
                                  : e.businessPartner?.[0]?.company_name}
                              </div>

                              <h4
                                className="f4 title"
                                style={{
                                  color: `var(--${
                                    e.id === activeData.id
                                      ? "primary"
                                      : "secondory"
                                  }-color)`,
                                }}
                              >
                                {e.vendor_customer_code || ""}
                              </h4>
                            </div>

                            <div className="side_content_footer">
                              <h4 className="f4 subtitle">
                                {e.city ?? e.contactAddress?.[0]?.city ?? "-"}
                              </h4>
                            </div>
                          </div>
                        </div>
                      ))}
                    </AccordionDetails>
                  </Accordion>
                )}
              </Fragment>
            ))}
          </div>
        </div>
        <div
          className={`mini_content_container`}
          style={{
            display: isMobileView && !activeData.id ? "none" : "initial",
          }}
        >
          {Object.keys(activeData).length === 0 ? (
            <div className="not_found_container">
              <img src={DataNotFound} alt="" />
              Please Select Any One Partner
            </div>
          ) : (
            <Fragment>
              <div className="main_stepper_container">
                <Stepper
                  activeStep={steperData}
                  alternativeLabel
                  connector={<ColorlibConnector />}
                  orientation="horizontal"
                >
                  {steps.map((label, index) => (
                    <Step key={label}>
                      <StepLabel
                        sx={{
                          color: "#82CA89",
                          "& .MuiStepLabel-label": {
                            whiteSpace: "nowrap",
                          },
                        }}
                        error={
                          isRejected
                            ? steperData === index
                              ? true
                              : false
                            : false
                        }
                        icon={
                          isRejected ? (
                            steperData === index ? (
                              <CancelIcon color="error" />
                            ) : (
                              ""
                            )
                          ) : (
                            ""
                          )
                        }
                      >
                        {label}
                      </StepLabel>
                    </Step>
                  ))}
                </Stepper>
              </div>

              <div className="content_header">
                <h4 className="f4 primary_text text_ellipsis">
                  {activeData.approvall
                    ? activeData.approvall.length !== 0
                      ? activeData.approvall[activeData.approvall.length - 1]
                          .description
                      : ""
                    : ""}{" "}
                </h4>
                {activeData.approvall.filter((a: any, index: number) => {
                  if (index === activeData.approvall.length - 1) {
                    if (
                      a.role_name === "management" &&
                      a.status === "Request send to management"
                    ) {
                      return a;
                    }
                  }
                }).length != 0 ? (
                  <div className="btns">
                    <Button
                      className="common_btn_outline"
                      disableRipple
                      onClick={() => {
                        RejectManagement();
                      }}
                    >
                      Reject
                    </Button>
                    <Button
                      className="common_btn"
                      disableRipple
                      onClick={() => {
                        handleClickOpen();
                      }}
                    >
                      Approve
                    </Button>
                    <Button
                      className="common_btn_outline"
                      disableRipple
                      onClick={() => {
                        EditManagement();
                      }}
                    >
                      Edit
                      <FontAwesomeIcon
                        icon="edit"
                        title="Edit partner onboarding"
                      />
                    </Button>
                  </div>
                ) : (
                  ""
                )}
              </div>

              <div className="scroll_content_container">
                <div className="grid_container common_border_bottom">
                  <div className="detail_item">
                    <label>Company Name</label>
                    <p className="f4">
                      {activeData.company_name
                        ? activeData.company_name
                        : activeData.businessPartner[0].company_name}
                    </p>
                  </div>
                  <div className="detail_item">
                    <label>Alternate Name</label>
                    <p>
                      {" "}
                      {activeData.foreign_name
                        ? activeData.foreign_name
                        : activeData.businessPartner[0].foreign_name}
                    </p>
                  </div>
                  <div className="detail_item">
                    <label>Business Type</label>
                    <p>
                      {activeData.bussiness_type_1
                        ? activeData.bussiness_type_1
                        : ""}
                    </p>
                  </div>
                  <div className="detail_item">
                    <label>Partner Type</label>
                    <p>
                      {activeData.partner_name
                        ? activeData.partner_name
                        : activeData.partner_type}
                    </p>
                  </div>
                  <div className="detail_item">
                    <label>Group Name</label>
                    <p>
                      {" "}
                      {activeData.groups_name
                        ? activeData.groups_name
                        : activeData.group_name}
                    </p>
                  </div>
                  <div className="detail_item">
                    <label>Branch</label>
                    <div className="branch_imgs">
                      {activeData.branch.map((e: any, key: number) => {
                        return (
                          <img
                            key={key}
                            src={configs.api + "/" + e.branch_logo}
                            alt="branch"
                          ></img>
                        );
                      })}
                    </div>
                  </div>
                  <div className="detail_item">
                    <label>Contact Person</label>
                    <p>{activeData.contact_person}</p>
                  </div>
                  <div className="detail_item">
                    <label>Contact Email Id</label>
                    <Tooltip title={activeData.contact_email}>
                      <p
                        style={{
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                        }}
                      >
                        {activeData.contact_email}
                      </p>
                    </Tooltip>
                  </div>
                  <div className="detail_item">
                    <label>Contact Phone No</label>
                    <p>{activeData.contact_phone}</p>
                  </div>
                  <div className="detail_item">
                    <label>Annual Turn Over</label>
                    <p> {activeData.annual_turnover}</p>
                  </div>
                  <div className="detail_item">
                    <label>Currency</label>
                    <p>
                      {activeData.currency_1
                        ? activeData.currency_1
                        : activeData.currency}
                    </p>
                  </div>
                  <div className="detail_item">
                    <label>Payment Terms</label>
                    <p>
                      {activeData.payments_terms
                        ? payment_terms.find(
                            (terms: any) =>
                              terms.value === activeData.payments_terms
                          ).label
                        : ""}
                    </p>
                  </div>
                  <div className="detail_item">
                    <label>Country</label>
                    <p>
                      {activeData.country_1
                        ? activeData.country_1
                        : activeData.country}
                    </p>
                  </div>{" "}
                  <div className="detail_item">
                    <label>State</label>
                    <p>
                      {activeData.state_1
                        ? activeData.state_1
                        : activeData.state}
                    </p>
                  </div>{" "}
                  <div className="detail_item">
                    <label>City</label>
                    <p>{activeData.city ? activeData.city : "-"}</p>
                  </div>{" "}
                  <div className="detail_item">
                    <label>About</label>
                    <p
                      className="text-justify"
                      style={{
                        textAlign: "justify",
                      }}
                    >
                      {activeData.about ? activeData.about : "-"}
                    </p>
                  </div>
                </div>
                {/* history */}
                <div className="content_header">
                  <h4 className="f4 primary_text">History</h4>
                </div>

                <Fragment>
                  {activeData.approvall
                    ? activeData.approvall.map((e: any, index: number) => {
                        const monthNames = [
                          "Jan",
                          "Feb",
                          "Mar",
                          "Apr",
                          "May",
                          "Jun",
                          "Jul",
                          "Aug",
                          "Sep",
                          "Oct",
                          "Nov",
                          "Dec",
                        ];
                        // create on
                        const data = { ...e };
                        const created_on = new Date(data.created_on);
                        // delete data.EffecDate;
                        const created_date =
                          created_on.getDate() +
                          "-" +
                          monthNames[created_on.getMonth()] +
                          "-" +
                          created_on.getFullYear();
                        data.created_on
                          ? (data.created_on = created_date)
                          : console.log("sdfdsf");
                        var seconds = created_on.getSeconds();
                        var minutes = created_on.getMinutes();
                        var hour = created_on.getHours();

                        return (
                          <div
                            className="grid_container common_border_bottom"
                            key={index + 1}
                          >
                            <div className="detail_item">
                              <label>Status</label>
                              <p className="f4">{e.status}</p>
                            </div>
                            <div className="detail_item">
                              <label>Name</label>
                              <p className="f4">{e.creater_name}</p>
                            </div>
                            <div className="detail_item">
                              <label>Date/Time</label>
                              <p className="f4">
                                {data.created_on},
                                {hour + ":" + minutes + ":" + seconds}
                              </p>
                            </div>
                          </div>
                        );
                      })
                    : ""}
                </Fragment>
              </div>
            </Fragment>
          )}

          {/* pop up diologs */}

          {/* management approve */}
          <Dialog
            PaperProps={{
              style: { width: "500px" },
            }}
            open={open}
            onClose={handleClose}
            maxWidth={"md"}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <div className="dialog_header common_border_bottom">
              <h4 id="alert-dialog-title" className="f4">
                {"Confirmation"}
              </h4>
              <CancelIcon
                onClick={() => {
                  handleClose();
                }}
              />
            </div>
            <DialogContent>Are you sure want to approve?</DialogContent>
            <DialogActions>
              <div className="dialog_footer">
                <Button
                  disableRipple
                  onClick={handleClose}
                  className="common_btn_outline"
                >
                  Cancel
                </Button>
                <Button
                  disableRipple
                  className="common_btn"
                  onClick={() => {
                    const data = {
                      id: activeData.id,
                      status: "approved",
                      description: "management approved",

                      url: "update_management",
                    };
                    if (!managementApproveApi.isLoading) {
                      dispatch(management_approve_partner(data));
                    }
                  }}
                >
                  {managementApproveApi.isLoading ? "Please Wait" : "Confirm"}
                </Button>
              </div>
            </DialogActions>
          </Dialog>

          {/* management reject reason */}
          <Dialog
            PaperProps={{
              style: { borderRadius: 0, width: "700px" },
            }}
            open={managementReject}
            onClose={ManagementRejectClose}
            maxWidth={"lg"}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <div className="dialog_header common_border_bottom">
              <h4 id="alert-dialog-title" className="f4">
                Reason for Rejection
              </h4>

              <CancelIcon
                onClick={() => {
                  ManagementRejectClose();
                }}
              />
            </div>

            <DialogContent>
              <Grid container rowSpacing={3} columnSpacing={3}>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <div className="field_item">
                    <label className="f4">About</label>
                    <TextField
                      fullWidth
                      id="reason-reject"
                      className="custom_textfield"
                      multiline
                      rows={4}
                      name="about"
                      onChange={handleChange}
                      value={values.about}
                      onBlur={handleBlur}
                      error={touched.about && errors.about ? true : false}
                      helperText={
                        touched.about && errors.about ? errors.about : ""
                      }
                    />
                  </div>
                </Grid>
              </Grid>
              {/* <DialogContentText id="alert-dialog-description"> */}
            </DialogContent>
            <DialogActions>
              <div className="dialog_footer">
                <Button
                  disableRipple
                  onClick={ManagementRejectClose}
                  className="common_btn_outline"
                >
                  Cancel
                </Button>
                <Button
                  disableRipple
                  className="common_btn"
                  onClick={() => {
                    handleSubmit();
                  }}
                >
                  {managementApproveApi.isLoading ? "Please Wait" : "Send"}
                </Button>
              </div>
            </DialogActions>
          </Dialog>
        </div>
      </div>
    </div>
  );
};
export default Management;
